import Marquee from "react-fast-marquee";

export default function BrandMarquee({ logo }) {
  return (
    <section
      data-testid="brand-marquee"
      className="py-10 md:py-16 border-y border-line bg-surface overflow-hidden"
    >
      <Marquee speed={45} gradient={false} autoFill>
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="flex items-center gap-8 md:gap-12 mx-8 md:mx-12">
            {logo ? (
              <img
                src={logo}
                alt="MO by Vir"
                className="h-24 md:h-36 lg:h-44 w-auto object-contain shrink-0"
              />
            ) : (
              <span className="font-serif italic text-6xl md:text-8xl text-outline whitespace-nowrap">
                MO by Vir
              </span>
            )}
            <span className="font-serif italic text-6xl md:text-8xl lg:text-9xl text-outline whitespace-nowrap">
              Luxury Mini Perfumes
            </span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
